export default __webpack_public_path__ + "static/media/image-jeremyrobson.71cd41f1.png";